import React from "react";


function Header(){
    return(
    <header id="header">
	<div className="container main-menu">
			<div className="row align-items-center d-flex">
				
				<nav id="nav-menu-container">
					<ul className="nav-menu">
						<li className=""><a className="active" href="#home">Home</a></li>
						<li><a href="#about-myself">About</a></li>
						<li><a href="#work">Portfolio</a></li>
					
					</ul>
				</nav>
			</div>
		</div>
	</header>)
}

export default Header